import { render, staticRenderFns } from "./DemoFormLayoutVerticalForm.vue?vue&type=template&id=01186c2a"
import script from "./DemoFormLayoutVerticalForm.vue?vue&type=script&lang=js"
export * from "./DemoFormLayoutVerticalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports